<div class="offcanvas offcanvas-end show" tabindex="-1" id="pujaCheckOut" aria-labelledby="offcanvasRightLabel"
	data-bs-backdrop="false">

	<div class="offcanvas-header">
		<h1>Product Order Details</h1>
		<button type="button" (click)="handleOffcanvasClose()" class="btn-close text-reset" data-bs-dismiss="offcanvas"
			aria-label="Close"></button>
	</div>
	<div class="offcanvas-body" *ngIf="orderData">
		<section class="order_details_new">
			<div class="order_field">
				<p>Product Name:</p>
				<p class="order_field_value">{{orderData?.orderDetails?.productName}}</p>
			</div>
			<div class="order_field">
				<p>Price:</p>
				<p class="order_field_value">{{gS.currencySign}} {{orderData?.orderDetails?.amount}}</p>
			</div>
			<div class="order_field">
				<p>Payment Status:</p>
				<p class="order_field_value">{{orderData?.orderDetails?.status}}</p>
			</div>

			<div class="order_field">
				<p>Order Date:</p>
				<p class="order_field_value">{{orderData?.orderDetails?.creationTime | date:'YY-MM-YYYY'}}</p>
			</div>
			<div class="order_field" *ngIf="orderData?.advisorProductOrder">
				<p>Order Status:</p>
				<p class="order_field_value">
					{{orderData?.advisorProductOrder?.orderStatus?orderData?.advisorProductOrder?.orderStatus.replaceAll("_","
					"):'N/A'}}</p>
			</div>
			<div class="order_field" *ngIf="orderData?.advisorProductOrder">
				<p>Consultant Name:</p>
				<p class="order_field_value">
					{{orderData?.orderDetails?.consultantName?orderData?.orderDetails?.consultantName:'N/A'}}</p>
			</div>
		</section>
		<p class="form_title">Form Details</p>
		<section class="order_details" *ngIf="orderData?.formFields">
			<ng-container *ngFor="let item of orderData?.formFields">
				<div class="form_field" *ngIf="item?.value">
					<p class="field_title">{{ item?.label }}</p>
					<div class="field_value">
						<p>{{ item?.value }}</p>
					</div>
				</div>
			</ng-container>
		</section>
	</div>
</div>